import React from 'react';
import Title from 'lib/src/components/typography/Title';
import DashboardTile from './DashboardTile';
import useRoles from 'lib/src/hooks/useRoles';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';

const options = [
    {
        title: 'Assessments',
        description: 'View and assess challenge applications',
        icon: 'clipboard',
        link: '/assessments',
        role: userRoles.assessor,
    },
    {
        title: 'Admins',
        description: 'View, add and edit admins in the system',
        icon: 'users-cog',
        link: '/admins',
        role: userRoles.admins,
    },
    {
        title: 'Users / SMES',
        description: 'View, add and edit users/SMEs in the system',
        icon: 'users',
        link: '/users',
        role: userRoles.users,
    },
    {
        title: 'Challenge Groups',
        description: 'View, add and edit challenges in the system',
        icon: 'trophy',
        link: '/challenge-groups',
        role: userRoles.challengeGroups,
    },
    {
        title: 'Challenges',
        description: 'View and edit challenges in the system',
        icon: 'trophy',
        link: '/challenges',
        role: userRoles.superAdmin,
    },
    {
        title: 'Challenge IX Programme',
        description: 'View, add and edit challenge tags in the system',
        icon: 'tags',
        link: '/tags/challenge',
        role: userRoles.challengeTags,
    },
    {
        title: 'Challenge Calendar',
        description: 'See challenges as project entries in a Gantt Chart',
        icon: 'calendar',
        link: '/calendar',
        role: userRoles.calendar,
    },
    {
        title: 'Contact Us Messages',
        description: 'View contact us messages in the system',
        icon: 'phone',
        link: '/contact-us-messages',
        role: userRoles.contactUsMessages,
    },
];

const Dashboard: React.FC = (): JSX.Element => {
    const roles = useRoles();
    return (
        <>
            <Title>Dashboard</Title>
            <div className="dashboard-tiles-container">
                {options.map(({ title, description, icon, link, role }, i) =>
                    roles.includes(role) || roles.includes(userRoles.superAdmin) ? (
                        <DashboardTile
                            key={i}
                            title={title}
                            icon={icon}
                            description={description}
                            path={link}
                        />
                    ) : (
                        <React.Fragment key={i} />
                    ),
                )}
            </div>
        </>
    );
};

export default Dashboard;
